
  export default {
    middleware: ['pages/products/banking/loans/index', 'breadcrumbs', 'meta-tags'],
    meta: {
      breadcrumbs: [['i18n/home', '/'], 'i18n/loans'],
      category: 'banking',
      metaTagOptions: { image: 'loans' }
    },
    created () {
      this.$store.dispatch('matomo/trackIndexPageViewed', { name: 'Loans index page viewed' });
    }
  };
